<script>
  import {
    bApp,
    baseTermUrl,
    insTypeOrders,
    preHandleKeys,
    diffShowKeys,
    hideKey
  } from 'base/config'
  import { formatTenThousand, formatASCII } from 'common/js/format'
  import Insurance from 'base/model/insurance'
  import Emitter from 'common/js/emitter'
  import {
    toggleClass,
    getScreenSize
  } from 'common/js/dom'
  import ToggleDesc from 'components/toggleDesc/toggleDesc'
  import PbDialog from 'components/dialog/dialog'

  const LEFT_WIDTH = 67 + 30 // 外层padding

  export default {
    components: {
      ToggleDesc,
      PbDialog
    },
    mixins: [Emitter],
    props: {
      temp: {
        type: Object,
        default: () => ({})
      },
      data: {
        type: Object,
        default: () => ({})
      },
      companyList: {
        type: Array,
        default() {
          return []
        }
      },
      profitBtn: {
        type: Object,
        default() {
          return {}
        }
      }
    },
    methods: {
      //
      /**
       * 显示/隐藏 责任
       * @param  {Element} dom [责任所在dom]
       */
      toggleDesc(dom) {

        dom.parentNode && toggleClass(dom.parentNode, 'ins-desc-show');
      },
      /**
       * 显示/隐藏 病种
       * @param  {Array} path [病种路径]
       */
      toggleDis(path) {
        this.$emit('disShow', path)
      },

      clickPftHandler(event, index) {
        event.stopPropagation()
        event.preventDefault()
        this.dispatch('InsResult', 'open-profit', index)
      },

      /**
       * 格式数据
       * @return {Object} [险种格式数据, 责任格式数据]
       */
      _normalizeData(template, index) {
        let temp = template.liabilities
        let arrangeInIns = []
        let arrangeInInsType = {}
        let arrangeBase = []
        let categorySort = temp.categorySort || 'normal'
        let insTypeOrder = insTypeOrders[categorySort]
        // let diseasesPath = []

        let product = temp[index]  // 产品

        let productId = product.productId // 产品id
        let insurance = product.insuranceLiabilities  // 险种
        let insuranceLen = insurance && insurance.length
        let arrangeProduct = []
        let disease  // 险种-所有责任的病重
        let instypeDisease = {}
        let diseaseTypes = {}
        let insuranceCompare = {}

        if (!insuranceLen) return
        for (let idx = 0; idx < insuranceLen; idx++) {
          let ins = insurance[idx]  // 险种
          let insId = ins.insuranceId // 险种id
          let insName = ins.insuranceName // 险种名字
          let liabilities = ins.liabilities // 责任
          let liabilitiesLen = liabilities && liabilities.length

          if (!liabilitiesLen) continue
          for (let lidx = 0; lidx < liabilitiesLen; lidx++) {
            let liab = liabilities[lidx]  // 责任
            let liabType = liab.categoryId     // 责任类别
            let liabTypeName = liab.categoryName // 责任类别名
            let liabOrder = insTypeOrder.indexOf(liabType) // 责任排序

            if (liabOrder < 0) continue
            if (!arrangeInInsType[liabOrder]) {
              arrangeInInsType[liabOrder] = true
            }

            const type = liab.disease.diseaseCategoryType
            const dsid = liab.disease.diseaseCategoryId
            const dkey = ['serious', 'disease', 'mild'][type - 1]

            if (dkey) {
              if (!insuranceCompare[dkey]) {
                insuranceCompare[dkey] = insId
              }
              if (!diseaseTypes[productId]) {
                diseaseTypes[productId] = {
                  [dkey]: dsid
                }
              } else if (!diseaseTypes[productId][dkey]) {
                diseaseTypes[productId][dkey] = dsid
              }
            }

            // 病种
            if (liab.disease && liab.disease.title) {
              disease = {
                pidx: index, // 产品index
                idx,  // 险种
                lidx  // 责任
              }
              if (Array.isArray(instypeDisease[liabOrder])) {
                instypeDisease[liabOrder].push(disease)
              } else {
                instypeDisease[liabOrder] = [disease]
              }



              // if (Array.isArray(insDisease[index])) {
              //   insDisease[index].push(disease)
              // } else {
              //   insDisease[index] = [disease]
              // }
              // 病种集合
              // diseasesPath.push(disease)
            }

            liab.productId = productId
            // 同责任不同产品
            if (arrangeBase[liabOrder] && Array.isArray(arrangeBase[liabOrder]['liabilities'])) {
              arrangeBase[liabOrder]['liabilities'].push(liab)
            } else {
              arrangeBase[liabOrder] = {
                productId: productId,
                liabilities: [liab],
                liabTypeName,
                liabOrder
                // itDisease: instypeDisease[liabOrder]
              }
            }
          }
          // arrangeProduct.push({
          //   productId,
          //   ins,
          //   disease
          // })
        }
        arrangeBase.forEach(item => {
          const itDisease = instypeDisease[item.liabOrder]
          if (instypeDisease[item.liabOrder]) {
            item.itDisease = itDisease
          }
        })
        arrangeInIns.push(arrangeProduct)

        return {
          // diseasesPath,
          arrangeInIns,
          arrangeInInsType,
          arrangeBase,
          diseaseTypes,
          insuranceCompare
        }
      },
      /**
       * 创建责任
       * @param  {Array} template [description]
       * @param  {Function} create
       */
      _createInsTypeVNodeV2(ins, planIndex, create) {
        let instypeAry = []
        let username = this.temp.name
        // let bToggleDesc = false
        // let instype = template[planIndex]

        // for (var index = 0; index < baseArray.length; index++) {
        //   if (!baseArray[index]) continue

        let insAry = []

        let bInstypeHideDesc = false
        let bInstypeDisease = false
        let bAddAndTake = 0

        if (ins) {
          let liabilities = ins.liabilities
          let productId = ins.productId
          let insChilds = []
          let liabTypeName = ins.liabTypeName

          // 条款 VNode
          let termVNode = create('a', {
            class: 'term-link',
            attrs: {
              href: `${baseTermUrl}?nw=1&name=${username}&termsId=${ins.insuranceId}`,
              'data-stat-id': 'tkxq',
              'data-stat-ep': JSON.stringify({
                productId: this.temp.insuranceTypeId
              })
            },
            domProps: {
              innerHTML: '条款'
            }
          })
          let headChilds = [ins.insuranceName, termVNode]
          let accountMap = ins.accountMap

          let {
            bDisease, bHideDesc
          } = this._haveDisease(liabilities)

          // 病种 VNode
          if (bDisease) {
            // !bInstypeDisease && (bInstypeDisease = true)
            bInstypeDisease = true
          }
          // 险种 head
          let insHeadVNode = create('h5', {
            class: 'ins-name'
          }, headChilds)
          insChilds.push(insHeadVNode)

          // 险种head都隐藏
          // bHideDesc = true;

          // 险种 body
          if (liabilities) {
            // 正常险种
            let insBodyChilds = this._createLiabilitiesV2(planIndex, productId, liabilities, create)
            let insBodyVNode = create('div', {
              class: 'ins-bd',
            }, insBodyChilds)
            insChilds.push(insBodyVNode)
          }

          // 追加领取
          if (accountMap) {
            let insAddAndTakeChilds = this._createAddAndTake(accountMap, create)
            if (insAddAndTakeChilds.length) {
              let insAddAndTakeVNode = create('div', {
                class: 'ins-bd add-take'
              }, insAddAndTakeChilds)
              insChilds.push(insAddAndTakeVNode)
              bAddAndTake++
            }
          }

          // 险种 foot
          let insFootVNode
          // !bInstypeHideDesc && bHideDesc
          if (bHideDesc) {
            // insFootVNode = create(ToggleDesc, {
            //   on: {
            //     toggle: this.toggleDesc
            //   }
            // })
            bInstypeHideDesc = bHideDesc
            insChilds.push(insFootVNode)
          }

          let insVNode
          insChilds.length && (insVNode = create('div', {
            class: 'ins-box'
          }, insChilds))

          // 类别名 设置一次
          // if (lidx === 0) {
          //   liabTypeName = ins.liabTypeName
          // }

          insChilds.length && insAry.push(insVNode)

          // 险种类别名
          // 没有险种信息（追加领取）
          if (insAry.length) {
            let instypeNameChild = [liabTypeName]

            let instypeNameVNode = create('h3', {
              class: 'instype-name',
            }, instypeNameChild)
            insAry.unshift(instypeNameVNode)

            if (bInstypeDisease) {
              let instypeDiseaseVNode = create('div', {
                class: 'disease-btn',
                domProps: {
                  innerHTML: '<a class="after-bdr">病种详情</a>'
                },
                on: {
                  click: this.clickHandler.bind(this, event, [ins.itDisease])
                },
              })
              insAry.push(instypeDiseaseVNode)
            }

            // 显示
            if (bInstypeHideDesc) {
              let instypeToggleFootVNode = create(ToggleDesc, {
                on: {
                  toggle: this.toggleDesc
                }
              });
              insAry.push(instypeToggleFootVNode)
            }

            let sectionClass = bAddAndTake > 0 ? (bAddAndTake > 1 ? 'instype-box addtake-box' : 'instype-box addtake-box no-title') : 'instype-box'
            let instypeVNodes = create('section', {
              class: bAddAndTake > 1 ? 'instype-box addtake-box' : 'instype-box'
            }, insAry)
            instypeAry.push(instypeVNodes)
          }
        } else {
          let instypeVNodes = create('section', {
              class: 'instype-box empty',
              domProps: {
                innerHTML: '<div class="ins-bd">—</div>'
              }
            }, insAry)
          instypeAry.push(instypeVNodes)
        }

        return create('article', {
          class: 'des-box',
          style: {
            width: `${this.itemWidth}px`,
          }
        }, instypeAry)
      },
      /**
       * 创建责任
       * @param  {Number} difIdx [产品序列，对比0、1]
       * @param  {Number} prodId [产品id]
       * @param  {Object} liab   [责任对象]
       * @return {Array}         [VNode, VNode]
       */
      _createLiabilitiesV2 (planIdx, prodId, liab, create) {
        let ret = []
        let targetAry = liab
        if (!Array.isArray(liab)) {
          targetAry = [liab]
        }
        targetAry.forEach((lib, idx) => {
          lib && diffShowKeys.forEach((sk, idx) => {
            let libItem = lib[sk]
            if (libItem) {
              let resultHTML
              try {
                resultHTML = this._format(prodId, libItem, this.data) //[planIdx]
              } catch (er) {
                resultHTML = this._formatLow(prodId, libItem, this.data); //[planIdx]
              }
              resultHTML = formatASCII(resultHTML)

              let libVNode
              // fix 无文字时插入空的dom
              if (resultHTML) {
                // 文字预处理
                preHandleKeys.length && preHandleKeys.forEach((pre, index) => {
                  if (pre.key === sk) {
                    resultHTML = pre.value.replace(/{(.*?)}/, resultHTML)
                  }
                })

                libVNode = create('div', {
                  class: sk,
                  domProps: {
                    innerHTML: resultHTML
                  }
                })
                ret.push(libVNode)
              }
            }
          })
        })

        return ret
      },
      /**
       * 险种下的责任是否有病种
       * @param  {Array/Object} data [责任]
       * @return {Boolean}           [是否有病种]
       */
      _haveDisease (data, type) {
        let bDisease = false
        let bHideDesc = false

        let targetAry = data
        if (!Array.isArray(data)) {
          targetAry = [data]
        }
        for (let index = 0; index < targetAry.length; index++) {
          if (targetAry[index].disease && targetAry[index].disease.title) {
            bDisease = true
          }
          if (targetAry[index][hideKey]) {
            bHideDesc = true
          }
          if ((type === 0 && bDisease) || (type === 1 && bHideDesc) || (!type && bDisease && bHideDesc)) break
        }
        return {
          bDisease,
          bHideDesc
        }
      },
      /**
       * 显示/隐藏 病种
       * @param  {Object} event
       * @param  {Object} path  [路径]
       */
      clickHandler(event, path) {

        this.dispatch('InsResult', 'open-disease', path)
      },
      /**
       * 转义，公共函数
       * @param  {[type]} templateData [pre模版，数据]
       * @return {[type]}              [模版]
       */
      _formatFnCenter(templateData) {
        var resultTemp = templateData[0];
        for (var i = 1; i < arguments.length; i++) {
          var arg = String(arguments[i]);

          // 金额显示整万
          if (templateData[i].match(/元/)) {
            arg = String(formatTenThousand(arg))
          }
          // 金额显示保留2位小数
          if (!isNaN(arg) && arg.split('.')[1]) {
            arg = arg.split('.')[1].length > 2 ? parseFloat(arg).toFixed(2) : arg
          }
          resultTemp += arg;
          resultTemp += templateData[i]
        }
        return resultTemp;
      },
      /**
       * 转义字符串模版
       * @param  {String} template [pre模版]
       * @param  {Object} data     [计算数据]
       * @return {String}          [模版]
       */
      _format(prodId, template, data) {
        let self = this
        let keys = Object.keys(data)
        let dataList
        dataList = keys.map(function (key) {
          // 根据产品id获取对应险种数据
          if (key.match(/i\d+/)) {
            if (data[key] && data[key]['p' + prodId]) {
              return data[key]['p' + prodId]
            } else {
              return new Insurance()
            }
          }
          return data[key]
        })
        // 这里使用反引号来构建模板引擎
        // let Fn = new Function
        let g = new Function(keys.join(','), 'return this._formatFnCenter `' + template + '`;')
        return g
            .apply(self, dataList)
      },
      /**
       * ios8-5c fix (_format) 方法
       */
      _formatLow(prodId, template, data) {
        let self = this;
        let temps = template.split(/\$\{(\w?[^\}]*)\}/g);
        let match = template.match(/(\\)?\{([^\{\}\\]+)(\\)?\}/g);
        let dataList
        let keys = Object.keys(data)
        dataList = keys.map(function (key) {
          // 根据产品id获取对应险种数据
          if (key.match(/i\d+/)) {
            if (data[key] && data[key]['p' + prodId]) {
              return data[key]['p' + prodId]
            } else {
              return new Insurance()
            }
          }
          return data[key]
        })
        if (match) {
          for(var i = 1; i < temps.length; i += 2){
            let ret = new Function(keys.join(','), 'return ' + temps[i] + ';').apply(self, dataList)

            // 金额显示整万
            if (temps[i + 1].match(/元/)) {
              ret = String(formatTenThousand(ret))
            }
            ret = '' + ret
            // 金额显示保留2位小数
            if (!isNaN(Number(ret)) && ret.split('.')[1]) {
              ret = ret.split('.')[1].length > 2 ? parseFloat(ret).toFixed(2) : ret
            }
            temps[i] = ret
          }
          return temps.join('')
        } else {
          return template
        }
      },
      /**
       * 空or空对象
       * @param  {Object|--}  obj [检测对象]
       * @return {Boolean}
       */
      _isEmpty(obj) {
        if (!obj) return true
        for (var name in obj) {
          return false
        }
        return true
      },
      _getMaxLen(ary) {
        let compare = []
        let result = []
        ary.forEach((item, index) => {
          compare[index] = item.length
        })
        let maxLen = Math.max(...compare)

        for (var index = 0; index < maxLen; index++) {
          let bHave = 0
          let name
          ary.forEach((item, idx) => {
            if (item[index]) {
              name = item[index].liabTypeName
            } else {
              bHave++
            }
          })
          // 存在其一则显示分类
          if (bHave !== ary.length && name) {
            result[index] = true
            this.liabTypeNameList.push(name)
          }
        }

        return result
      },
      getPerson(key, person) {
        if (person[key]) {
          let {
            age,
            sex
          } = person[key]
          sex = sex === 2 ? '女' : '男'
          return `${sex} ${age}岁`
        }
      }
    },
    // 依据大类型
    render: function (createElement) {
      let arrangeBase = []
      let temp = this.temp
      const width = Math.min(getScreenSize().width, 480)
      this.itemWidth = Math.round((width - LEFT_WIDTH) / 2)
      this.liabTypeNameList = []
      this.ovNameList = []

      const {
        prodOrderList,
        trades
      } = temp

      let diseaseBaseTypes = {}
      let insuranceBaseCompare = {}
      this.arrangeInInsType = {}

      for (var i = 0, j = prodOrderList.length; i < j; i++) {
        let product = prodOrderList[i]
        const normalizeData = this._normalizeData(temp, i)
        const diseaseTypes = normalizeData.diseaseTypes
        const insuranceCompare = normalizeData.insuranceCompare
        arrangeBase[i] = normalizeData.arrangeBase
        this.arrangeInInsType = Object.assign({}, normalizeData.arrangeInInsType, this.arrangeInInsType)

        Object.keys(insuranceCompare).length > 0 && (insuranceBaseCompare[product.key] = insuranceCompare)
        diseaseBaseTypes = Object.assign({}, diseaseBaseTypes, diseaseTypes)
      }

      this.dispatch('InsResult', 'set-instype', this.arrangeInInsType)
      this.dispatch('InsResult', 'set-distypes', {diseaseBaseTypes, insuranceBaseCompare })

      let insTypeAry = []
      let insPtAry = []
      let insTdAry = []

      let baseArray = this._getMaxLen(arrangeBase)

      // 责任种类
      baseArray.forEach((base, index) => {
        let theInsTypeAry = []
        prodOrderList.forEach((product, pIndex) => {
          theInsTypeAry.push(this._createInsTypeVNodeV2(arrangeBase[pIndex][index], pIndex, createElement))
        })
        const theInsTypeVNode = createElement('div', {
          class: 'one-instype-item'
        }, theInsTypeAry)
        insTypeAry.push(theInsTypeVNode)
      })

      let thePtAry = []
      let theAdAry = []
      let theNameAry = []
      prodOrderList.forEach((item, index) => {
        const productId = item.key
        const desBtn = createElement('a', {
          class: 'open-profit after-bdr',
          attrs: {
            'data-stat-id': 'cklyysb'
          },
          on: {
            click: this.clickPftHandler.bind(this, event, index)
          },
          domProps: {
            innerHTML: '查看利益演示表'
          },
        })
        const desShow = this.profitBtn[productId]
        const desBox = createElement('div', {
          class: 'des-box',
          style: {
            width: `${this.itemWidth}px`,
          }
        }, [desShow ? desBtn : '—'])
        let tradeBtn = '—'
        if (item.tradeId && Array.isArray(trades)) {
          const trade = trades.filter(t => {
            return t.productId === productId
          })[0]
          if (trade && trade.productInfo) {
            tradeBtn = createElement('a', {
              class: 'jumpto-trade after-bdr',
              attrs: {
                'href': bApp ? trade.productInfo.tradeUrl : trade.productInfo.shareTradeUrl
              },
              domProps: {
                innerHTML: '立即投保'
              },
            })
          }
        }
        const tradeBox = createElement('div', {
          class: 'des-box',
          style: {
            width: `${this.itemWidth}px`,
          }
        }, [tradeBtn])
        const nameBox = createElement('div', {
          class: 'des-box',
          style: {
            width: `${this.itemWidth}px`,
          }
        }, [item.titleName])

        theAdAry.push(tradeBox)
        thePtAry.push(desBox)
        theNameAry.push(nameBox)
      })
      const theInsPtVNode = createElement('div', {
        class: 'one-instype-item'
      }, thePtAry)
      insPtAry.push(theInsPtVNode)
      const theInsTdVNode = createElement('div', {
        class: 'one-instype-item'
      }, theAdAry)
      insTdAry.push(theInsTdVNode)

      const theNameVNode = createElement('div', {
        class: 'one-instype-item after-bd-b'
      }, theNameAry)


      this.$nextTick(() => {
        let leftInfo = [{
          name: '',
          height: theNameVNode.elm.clientHeight
        }]

        insTypeAry.forEach((item, index) => {
          let _VNodeElm = item.elm
          leftInfo.push({
            name: this.liabTypeNameList[index],
            height: _VNodeElm.clientHeight
          })
        })
        this.dispatch('InsResult', 'init-left', leftInfo)
      })

      const planNameVNode = createElement('div', {
        class: 'plan-book-overview'
      }, [theNameVNode])

      const planLbVNode = createElement('div', {
        class: 'plan-book-libility'
      }, insTypeAry)

      const planPfVNode = createElement('div', {
        class: 'plan-book-profit after-bd-b'
      }, insPtAry)

      const tradingVNode = createElement('div', {
        class: 'plan-book-trade'
      }, insTdAry)

      const planBookVNode = createElement('div', {
        class: 'plan-book-fast'
      }, [planNameVNode, planLbVNode, planPfVNode, tradingVNode])

      return planBookVNode
    }
  }
</script>